module.exports = __webpack_public_path__ + "static/media/pdf.3fa92281.svg";